import React, { lazy, useEffect, useState } from 'react';

import { Auth as AuthAmplify } from 'aws-amplify';
import { Route, Router, Switch } from 'react-router-dom';
import { Loading } from './components/Loading';
import { Alert } from './components/Alert';
import history from './utils/history';
import ROUTES from './routes';
import PrivateRoleRoute from './scenes/Route/PrivateRoleRoute';
import { localStorageClean, localStorageSet, /*localStorageHas*/ } from './utils/storage';
import 'moment/locale/es';
import Moment from 'react-moment';

Moment.globalLocale = 'es';
Moment.globalLocal = true;
const Login = lazy(() => import('./scenes/Login'));

const App = () => {
  const [isLoading, setIsLoading] = useState(true);

  // console.log = function() {}

  useEffect(() => {
   // setTimeout(() => {
      AuthAmplify.currentSession()
        .then((res: any) => {
          console.log(res)
          const {idToken = {}} = res;
          localStorageSet('tkn', idToken.jwtToken);
        })
        .catch(res => {
          console.error('Scratch ->' + res);
          localStorageClean();
          AuthAmplify.signOut().then(() => {
            history.push('/');
          })
        })
        .finally(() => {
          setIsLoading(false)
        })
    //}, localStorageHas('tkn') ? 0 : 3000);
  }, []);

  return (
    <Router history={history}>
      <React.Suspense fallback="">
      {!isLoading && (
          <>
            <Alert />
            <Loading />
            <Switch>
              <Route path={ROUTES.ROOT} exact component={Login} />
              <Route path="" component={PrivateRoleRoute} />
            </Switch>
          </>
        )
      }
      </React.Suspense>
    </Router>
  );
}

export default App;
